import { Directive, HostListener } from '@angular/core';
import { FormNames } from '../models/enums/form-names';
import { QuoteSteps } from '../models/enums/quote-steps';
import { MotorQuoteStateService } from '../services/motor-quote-state/motor-quote-state.service';
import { StatePersistenceService } from '../services/state-persistence/state-persistence.service';

@Directive({ selector: '[appUnloadBrowserNotification]' })

export class UnloadBrowserNotificationDirective {

    constructor(private readonly motorQuoteStateService: MotorQuoteStateService,
        private readonly statePersistenceService: StatePersistenceService) {
    }

    @HostListener('window:pagehide', ['$event']) async beforeUnloadNotification($event: any) {
        this.statePersistenceService.saveState();
    }

    private showUnLoadMessage($event: any): string {
        const result = this.motorQuoteStateService.getFormState(FormNames.quoteForm)?.form?.dirty;
        if (result) {
            if (this.motorQuoteStateService.getCurrentStep() !== QuoteSteps.none &&
                this.motorQuoteStateService.getCurrentStep() !== QuoteSteps.selectProduct &&
                this.motorQuoteStateService.getCurrentStep() !== QuoteSteps.quickQuestionConfirmation &&
                this.motorQuoteStateService.getCurrentStep() !== QuoteSteps.confirmation) {
                var confirmationMessage = 'Changes you made may not be saved.';
                ($event || window.event).returnValue = confirmationMessage; //Gecko + IE
                ($event || window.event).cancelBubble = true;
                return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
            }
        }
        return '';
    }
}